module.exports = "<list-view\n  title=\"Variable Plans\"\n  transformer=\"VariablePlansTransforms\"\n  item-state=\"variableplan\"\n  resource=\"VariablePlan\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  limit=\"$ctrl.limit\"\n  no-items-text=\"No Variable Plans Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/variablePlans/variablePlans.html
// module id = 2092
// module chunks = 0